import * as actionTypes from 'constants/ActionTypes';

export function createTcOrders(tcOrders) {
    return {
        type: actionTypes.CREATE_TC_ORDERS,
        items: tcOrders,
    };
}

export function updateTcOrder(numberOrder, newTcOrder) {
    return {
        type: actionTypes.UPDATE_TC_ORDER,
        numberOrder,
        newTcOrder,
    };
}

export function addTcOrder() {
    return {
        type: actionTypes.ADD_TC_ORDER,
    };
}

export function removeLastTcOrder() {
    return {
        type: actionTypes.REMOVE_LAST_TC_ORDER,
    };
}

export function updateTcOrderUser(user) {
    return {
        type: actionTypes.UPDATE_TC_ORDER_USER,
        user,
    };
}

export function resetTcOrders() {
    return {
        type: actionTypes.RESET_TC_ORDERS,
    };
}



// WEBPACK FOOTER //
// ./app/actions/tc/orders.js